import "browser-report";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import React from "react";
import i18n from "i18next";

import { FeedbackPopup } from "../Layout/FeedbackPopup";
import { Panel, PanelHeader } from "../Layout/Panel";
import { getUserName } from "../../helpers/userHelpers";
import { reinitializeContactUsSendSucceeded, sendContactUsMessage } from "../../actions";
import ContactUsForm from "./ContactUsForm";

class ContactUsPage extends React.PureComponent {
  static propTypes = {
    reinitializeContactUsSendSucceeded: PropTypes.func.isRequired,
    sendContactUsMessage: PropTypes.func.isRequired,
    sendSucceeded: PropTypes.bool.isRequired,
    transition: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
    senderEmail: PropTypes.string,
    senderName: PropTypes.string
  };

  static defaultProps = {
    senderEmail: "",
    senderName: ""
  };

  componentDidUpdate(prevProps) {
    if (this.props.sendSucceeded && !prevProps.sendSucceeded) {
      setTimeout(this.handleGoBack, 1450);
    }
  }

  componentWillUnmount() {
    this.props.reinitializeContactUsSendSucceeded();
  }

  handleGoBack = () => {
    const { transition } = this.props;
    const previousState = transition.from();

    if (previousState.abstract) {
      transition.router.stateService.go("home");
    } else {
      transition.router.stateService.go(previousState, transition.params("from"));
    }
  };

  handleSubmit = values => {
    const { senderName, senderEmail } = this.props;
    let fullMessage = { ...values, senderName, senderEmail, sendTo: "helpDesk" };

    if (values && values.messageType === "report") {
      const { cookies, flash, ip, java, scripts, websockets, ...browserReport } = window.browserReportSync(); // eslint-disable-line
      fullMessage = { ...fullMessage, issue: JSON.stringify({ browserReport }) };
    }

    this.props.sendContactUsMessage(fullMessage);
  };

  render() {
    const { sendSucceeded, isMobile } = this.props;

    return (
      <Panel className="notification__panel">
        <PanelHeader id={i18n.t("contactUs.contactUs")} isMobile={isMobile} />
        <ContactUsForm onSubmit={this.handleSubmit} onGoBack={this.handleGoBack} />
        {sendSucceeded && <FeedbackPopup message={i18n.t("contactUs.messageSent")} />}
      </Panel>
    );
  }
}

const mapStateToProps = state => {
  return {
    isMobile: state.app.isMobile,
    sendSucceeded: state.contactUs.sendSucceeded,
    senderName: getUserName(state.app.user),
    senderEmail: state.app.user.email
  };
};

export default connect(
  mapStateToProps,
  { reinitializeContactUsSendSucceeded, sendContactUsMessage }
)(ContactUsPage);



// WEBPACK FOOTER //
// ./src/components/ContactUs/ContactUsPage.js